import Logo from "../../assets/images/touramp.png";
import { Link } from "react-router-dom";

import Facebook from "../../assets/icons/facebook.svg";
import Twitter from "../../assets/icons/twitter.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Linkedln from "../../assets/icons/linkedin.svg";

const Footer = () => {
  const linkLinks = [
    {
      to: "/about",
      text: "About Us",
    },
    {
      to: "/faq",
      text: "FAQ",
    },
    {
      to: "/",
      text: "Touramp Prime",
    },
    {
      to: "/",
      text: "Blog",
    },
    {
      to: "/contact",
      text: "Contact Us",
    },
  ];

  const joinLink = [
    {
      to: "/",
      text: "Careers",
    },
    {
      to: "/",
      text: "Partners",
    },
    {
      to: "/",
      text: "Couriers",
    },
    {
      to: "/",
      text: "Touramp Business",
    },
  ];

  const policyLink = [
    {
      to: "/terms-conditions",
      text: "Terms & conditions",
    },
    {
      to: "/privacy-policy",
      text: "privacy policy",
    },
    {
      to: "/return-policy",
      text: "Refund Policy",
    },
    {
      to: "/cookie-policy",
      text: "Cookie Policy",
    },
    {
      to: "/cancellation-policy",
      text: "Cancellaton Policy",
    },
  ];
  return (
    <div className="bg-[#FFF7F3]">
      <div className="container mx-0 lg:mx-auto flex flex-col justify-center items-center py-6 text-black">
        <div className="flex flex-col md:flex-row w-full px-4 gap-14 pt-10">
          {/*  */}
          <div className="flex flex-col gap-4 items-center md:items-start md:mr-16">
            <Link to="/home">
              <img src={Logo} className="w-28" alt="" />
            </Link>
            <div className="text-sm font-semibold whitespace-nowrap">
              Serving delicious food since the 80’s
            </div>
            <div className="flex gap-2">
              <a href="https://www.facebook.com/tourampfood/?ref=page_internal">
                <img src={Facebook} alt="" />
              </a>
              <a href="https://www.instagram.com/tourampfood/?hl=en">
                <img src={Instagram} alt="" />
              </a>
              <a href="https://twitter.com/tourampfood?lang=en">
                <img src={Twitter} alt="" />
              </a>
              <a href="https://www.linkedln.com">
                <img src={Linkedln} alt="" />
              </a>
            </div>
          </div>
          {/*  */}
          <div className="grid  grid-cols-2 md:grid-cols-3  gap-y-10 justify-between items-start w-full">
            <div className="flex flex-col justify-center items-start">
              <div className="font-semibold text-[22px]  ">Company</div>
              <div>
                {linkLinks.map((item) => (
                  <div className=" mt-2" key={item.text}>
                    <Link to={item.to}>{item.text}</Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center items-start">
              <div className="font-semibold text-[22px]  ">Join Us</div>
              <div>
                {joinLink.map((item) => (
                  <div className=" mt-2" key={item.text}>
                    <Link to={item.to}>{item.text}</Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center items-start">
              <div className="font-semibold text-[22px]  ">Legal</div>
              <div>
                {policyLink.map((item) => (
                  <div className=" mt-2 capitalize" key={item.text}>
                    <Link to={item.to}>{item.text}</Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 text-sm">
          <div>Copyright &copy; Touramp 2023 | Privacy Policy</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
